import React from 'react';
import { Sparkles, Utensils, Moon, Heart } from 'lucide-react';
export function TransformationSection() {
  return <section className="bg-gradient-to-b from-black to-[#111111] py-24 px-4 text-center pt-[40px] pb-[40px]" data-id="element-119">
      <div className="max-w-3xl mx-auto" data-id="element-120">
        <h2 className="text-3xl md:text-5xl font-bold mb-8 text-white" data-id="element-121">
          Imagine a Morning{' '}
          <span className="text-orange-500" data-id="element-122">Without Hissing</span>
        </h2>

        <div className="prose prose-lg prose-invert mx-auto" data-id="element-123">
          <ul className="list-none space-y-4 text-left mt-6 not-prose" data-id="element-124">
            <li className="flex items-start gap-4" data-id="element-125">
              <div className="p-2 bg-orange-500/10 rounded-full mt-0.5 shrink-0" data-id="element-126">
                <Utensils className="w-5 h-5 text-orange-400" data-id="element-127" />
              </div>
              <p className="text-xl text-gray-300 leading-relaxed" data-id="element-128">
                Both cats are eating{' '}
                <span className="text-white font-semibold" data-id="element-129">side-by-side</span>,
                calm and unbothered.
              </p>
            </li>
            <li className="flex items-start gap-4" data-id="element-130">
              <div className="p-2 bg-orange-500/10 rounded-full mt-0.5 shrink-0" data-id="element-131">
                <Moon className="w-5 h-5 text-orange-400" data-id="element-132" />
              </div>
              <p className="text-xl text-gray-300 leading-relaxed" data-id="element-133">
                You find them{' '}
                <span className="text-white font-semibold" data-id="element-134">
                  napping on the same rug
                </span>
                , peaceful and close.
              </p>
            </li>
            <li className="flex items-start gap-4" data-id="element-135">
              <div className="p-2 bg-orange-500/10 rounded-full mt-0.5 shrink-0" data-id="element-136">
                <Heart className="w-5 h-5 text-orange-400" data-id="element-137" />
              </div>
              <p className="text-xl text-gray-300 leading-relaxed" data-id="element-138">
                <span className="text-white font-semibold" data-id="element-139">
                  No stress. No guilt. No fear.
                </span>{' '}
                Just the happy, multi-cat family you always dreamed of.
              </p>
            </li>
          </ul>
        </div>
      </div>
    </section>;
}